// Shared Kudos Types Configuration
// Used across KudosSection, AttendeeDetailModal, and KudoDescriptionBubble

import KudoPersonalityPresence from '../img/icons/Kudo_Personality_Presence.png';
import KudoExcellentTechnique from '../img/icons/Kudo_Excellent_Technique.png';
import KudoCreativityPlay from '../img/icons/Kudo_Creativity_Play.png';
import KudoSafeSpaceConnection from '../img/icons/Kudo_Safe_Space_Connection.png';
import KudoOtherMagic from '../img/icons/Kudo_Other_Magic.png';

const KUDOS_TYPES = [
  {
    id: 'personality_presence',
    label: 'Personality & Presence',
    icon: KudoPersonalityPresence,
    description: `In stillness or step, you hold the space,
A grounded calm with honest grace.
The dance feels richer, deeper, true,
And space is warmer because of you.`,
  },
  {
    id: 'excellent_technique',
    label: 'Excellent Technique',
    icon: KudoExcellentTechnique,
    description: `Precision soft, control refined,
Body and timing well-aligned.
Strong foundations, not for show,
Your technique is why we flow.`,
  },
  {
    id: 'creativity_play',
    label: 'Creativity & Play',
    icon: KudoCreativityPlay,
    description: `You twist the familiar, soft and light,
Letting new movements come and go.
Not to impress, but to invite
A play, creating dance to call your own.`,
  },
  {
    id: 'safe_space_connection',
    label: 'Safe Space & Connection',
    icon: KudoSafeSpaceConnection,
    description: `You listen closely, feel, adapt,
Creating trust in every step.
The dance feels open, calm, and kind,
A shared connection, well-aligned.`,
  },
  {
    id: 'other_magic',
    label: 'Other Magic',
    icon: KudoOtherMagic,
    hasMessage: true,
    description: `The magic lived in our dance
Is one that can not be condensed.
Too layered, deep and rare to weight
Through my own words to be expressed.`,
  },
];

export const getKudosTypeById = (typeId) => {
  return KUDOS_TYPES.find(t => t.id === typeId) || KUDOS_TYPES[4];
};

export default KUDOS_TYPES;
